const wrapper = document.querySelector('.testimonials-wrapper');
const slides = document.querySelectorAll('.testimonial-wrapper');
const stepper = document.querySelectorAll('ul.stepper-container > li');

const singleSlideWidth = slides[0].offsetWidth;
const slidesLength = slides.length;
const initPosition = wrapper.style.left;

let slideInterval;

stepper[0].classList.add('active');
stepper.forEach((element, index) => {
    element.addEventListener('click', () => {
        if (index === 0) {
            wrapper.style.left = '12px';
            setActiveStepper(0);
        } else {
            showSlide(index);
        }
        slideTestimonials(index + 1);
    });
});

function setActiveStepper(activeIndex) {
    stepper.forEach((element, index) => {
        element.classList.toggle('active', index === activeIndex);
    });
}

function initSlider() {
    wrapper.style.left = initPosition;
    const slidesWidth = singleSlideWidth * slides.length;
    const containerWidth = wrapper.offsetWidth;

    document.querySelectorAll('.testimonial-wrapper.clone').forEach(element => element.remove());

    if (slidesWidth > containerWidth) {
        slides.forEach(element => {
            const clonedTestimonial = element.cloneNode(true);
            clonedTestimonial.classList.add('clone');
            wrapper.appendChild(clonedTestimonial);
        });
    }
}

function showSlide(n) {
    wrapper.classList.remove('shifting');
    const index = (n + slides.length) % slides.length;
    const widthToMove = singleSlideWidth + 12;

    setActiveStepper(index);

    if (index === 0) {
        wrapper.style.left = -slidesLength * widthToMove + 'px';
        setTimeout(() => {
            wrapper.classList.add('shifting');
            wrapper.style.left = '0';
        }, 1000);
    } else {
        wrapper.style.left = -index * widthToMove + 'px';
    }
}

function slideTestimonials(startFrom = 0) {
    clearInterval(slideInterval);
    const slidesWidth = singleSlideWidth * slides.length;
    const containerWidth = wrapper.offsetWidth;

    if (slidesWidth > containerWidth) {
        const overFlow = slidesWidth - containerWidth;
        const timesToSlide = Math.floor(overFlow / singleSlideWidth) + 1;
        let i = startFrom;

        slideInterval = setInterval(() => {
            showSlide(i);
            i = (i % slides.length) + 1;
        }, 4000);
    }
}

initSlider();
slideTestimonials();

window.onresize = () => {
    initSlider();
    slideTestimonials();
};
